"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var YouTubeAccountComponent = (function () {
    function YouTubeAccountComponent() {
        this.controller = YouTubeAccountController;
        this.template = require("./account.html");
    }
    return YouTubeAccountComponent;
}());
exports.default = YouTubeAccountComponent;
var YouTubeAccountController = (function () {
    function YouTubeAccountController($rootScope, youtubeService) {
        "ngInject";
        this.$rootScope = $rootScope;
        this.youtubeService = youtubeService;
    }
    Object.defineProperty(YouTubeAccountController.prototype, "isAuthorized", {
        get: function () {
            return this.$rootScope.isAuthorized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTubeAccountController.prototype, "username", {
        get: function () {
            return this.$rootScope.currentUser.getName();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTubeAccountController.prototype, "imageUrl", {
        get: function () {
            return this.$rootScope.currentUser.getImageUrl();
        },
        enumerable: true,
        configurable: true
    });
    YouTubeAccountController.prototype.$onInit = function () {
    };
    YouTubeAccountController.prototype.login = function () {
        this.youtubeService.login();
    };
    YouTubeAccountController.prototype.logout = function () {
        this.youtubeService.logout();
    };
    return YouTubeAccountController;
}());



/** WEBPACK FOOTER **
 ** ./src/app/common/youtube/account.component.ts
 **/